import React from "react"

export const withNavigationHeaderDesktopDropdownFeatured = Component => ({ name = "NavigationHeaderDesktopDropdownFeatured", item }) => {
  const { items, image, featuredLink, giftCards } = item

  Component.displayName = name
  return <Component items={items} type={"columns"} image={image} featuredLink={featuredLink} giftCards={giftCards} />
}
